/**
 * Check the status of an http request, and return true if the status supports continued processing.
 *
 * @param response - The request to check
 * @returns true if continued processiong is viable.
 */
export default function shouldProcessContentResponse(
  response: XMLHttpRequest
): boolean {
  if (!response) {
    return true;
  }
  switch (response.status) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Status
    case 401:
    case 402:
    case 403:
    case 406:
    case 407:
    case 449:
      return false;
    default:
      return true;
  }
}
